import React from "react";
import styled from 'styled-components';
import siemenslogo from "../../../assets/images/siemens.png";

// Styled components
const Section = styled.section`
  padding: 100px 20px;
  background: #062c3f;
    font-family: "Poppins", sans-serif;

  @media (max-width: 768px) {
    padding: 40px 15px;
  }

  @media (max-width: 576px) {
    padding: 30px 10px;
  }
`;

const PartnerContent = styled.div`
  text-align: left;
  height: fit-content;

  @media (max-width: 768px) {
    text-align: center;
  }
`;

const PartnerHeading = styled.h4`
  font-size: 3em;
  color: #00cbf1;
  position: relative;
  text-align: left;
  font-family: "Poppins", sans-serif;
  font-weight: 700;
  font-style: normal;

  span {
    color: #f0faff;
  }

 

  @media (max-width: 768px) {
    font-size: 1.8rem;
   
  }

  @media (max-width: 576px) {
    font-size: 2em;
  }
`;

const PartnerSubtitle = styled.h4`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 2rem;
   font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-style: normal;
  font-size: 1.8em;

  color: #00cbf1;

  @media (max-width: 768px) {
    font-size: 1.5rem;
    margin-top: 1rem;
  }

  @media (max-width: 576px) {
    font-size: 1rem;
    justify-content: left;
  }
`;

const PartnerText = styled.p`
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 1.1em;
  color: #fff;
  margin-top: 1.5rem;
  text-align: justify;
  line-height: 2.5;


  @media (max-width: 768px) {
    font-size: 0.9rem;
    text-align: justify;
  }

  @media (max-width: 576px) {
    font-size: 1em;
    text-align: justify;
    line-height: 1.71;
  }
`;

const PartnerImage = styled.img`
  width: 70%;
  padding: 20px 0;

  @media (max-width: 992px) {
    width: 80%;
  }

  @media (max-width: 768px) {
    width: 100%;
    padding: 10px 0;
  }
`;

const OurPartners = () => {
  return (
    <Section className="ourpartner-section">
      <div className="container">
        <div className="row">
          <div className="col-md-6 d-flex align-items-center">
            <PartnerContent >
              <PartnerHeading >
                Our <span>Partners </span>
              </PartnerHeading>
              <PartnerSubtitle >
                Partner-driven Hyper Growth
              </PartnerSubtitle>
              <PartnerText>
                Our partners drive our growth and success. We believe in
                creating a successful partnership ecosystem that delivers value
                to our customers. Our partner network is built on the foundation
                of trust, collaboration, and innovation. We have partnered with
                some of the leading technology companies to deliver cutting-edge
                solutions to our customers.
              </PartnerText>
            </PartnerContent>
          </div>
          <div className="col-md-6 d-flex align-items-center justify-content-center">
            <PartnerImage src={siemenslogo} alt="partner1" className="img-fluid-partner" />
          </div>
        </div>
      </div>
    </Section>
  );
};

export default OurPartners;
